<template>
    <div class="super-header">
        <p class="free-shipping-text">
            <a href="/products-cards-bra-center">
                Aproveite o <b style="color: lightgreen;">Frete Grátis*</b> em Produtos <b style="color: red;">B</b><b
                    style="color: blue;">R</b><b style="color: red;">A</b> Center!
            </a>
            <small style="font-size: 9px;color:lightgray">veja as regras!</small>
        </p>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    computed: {
    },
};
</script>

<style scoped>
.super-header {
    width: 100%;
    /* Ajuste a largura aqui */
    max-width: 600px;
    /* Limita a largura máxima, se necessário */
    /* background-color: #262626; */
    color: #ffffff;
    text-align: center;
    padding: 8px 0;
   
    /* animation: slideIn 1s ease-out; */
}

/* Texto do aviso */
.free-shipping-text {
    font-weight: bold;
    font-size: 1.2rem;
    animation: pulse 2s infinite;
}

/* Animação de entrada */
@keyframes slideIn {
    from {
        transform: translateY(-30%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Animação de "pulsar" para chamar atenção */
@keyframes pulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }
}
</style>